// Packages Import
import { memo, useState, useEffect} from "react"
import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
	GridToolbarColumnsButton,
	GridToolbarFilterButton,
	GridToolbarExport,
	GridToolbarDensitySelector,
} from "@mui/x-data-grid";
// Project Components
import InfoTable from "../../../UI/Table"
import { CustomAccordion, CustomAccordionDetails, CustomAccordionSummary } from "../../../UI/CustomAccordion";
import {formatDate} from "../../../Util/Util"
import { cmActions } from "../../../../store/CM/CM-slice"

const columnsSettings = [
	{ field: "cmName", headerName: "CM Name", type: "text", minWidth: 50, flex: 0.5 },
	{ field: "cmLoc", headerName: "CM Loc", type: "text", minWidth: 70, flex: 0.5 },
	{ field: "annPurchHist", headerName: "Annual Purchase", type: "text", minWidth: 50, flex: 0.5 },
    { field: "annFor", headerName: "Annual For", type: "text", minWidth: 50, flex: 0.5 },
    { field: "grossReq", headerName: "12m gross reqs", type: "text", minWidth: 50, flex: 0.5 },
    { field: "commodity", headerName: "Commodity", type: "text", minWidth: 50, flex: 0.5 },
    { field: "er", headerName: "ER", type: "text", minWidth: 50, flex: 0.5 },
    { field: "supplier", headerName: "Supplier", type: "text", minWidth: 50, flex: 0.5 },
    { field: "mpn", headerName: "MPN", type: "text", minWidth: 50, flex: 0.5 },

]


const CMForecastTable = (props) => {
	const dispatch = useDispatch();
	const [CMForecastAccordian, setCMForecastAccordian] = useState(false);
	const rows = useSelector((state) => state.cmState.CM_FORECAST_TABLE)
	const partNum = useSelector((state) => state.cmState.PART_INFO.partNum)
	const columnVisibility = useSelector((state) => state.cmState.tableColumnVisibilityCMForecast)

	const customToolBar = () => (
		<>
			<GridToolbarColumnsButton />
			<GridToolbarFilterButton />
			<GridToolbarDensitySelector />
			<GridToolbarExport 
				printOptions={{
					disableToolbarButton: true,
				}} 
				csvOptions={{
					fileName: `CM_Forecast_KPN${partNum}_${formatDate(new Date(), "")}`
				}}
			/>
		</>
	)
	useEffect(() => {
		setCMForecastAccordian(JSON.parse(localStorage.getItem("CMForecastAccordian")));
	}, []);

	// Store Accordion state into browser's local storage
	const accordionClicked = () => {
		window.localStorage.setItem("CMForecastAccordian", !CMForecastAccordian);
		setCMForecastAccordian(!CMForecastAccordian);
	};
	return (
		<CustomAccordion onChange={accordionClicked} expanded={CMForecastAccordian}>
			<CustomAccordionSummary aria-controls="panel1a-content" id="panel1a-header">
				<Typography sx={{ fontWeight: "bold" }}>CM Forecast</Typography>
			</CustomAccordionSummary>
			<CustomAccordionDetails>
				<InfoTable 
				columnsSettings={columnsSettings} 
				rows={rows}
				checkboxSelection = {true}
				customToolBar={customToolBar}
				ExtraProps = {{
					columnVisibilityModel:columnVisibility,
					onColumnVisibilityModelChange:(newModel) =>{
						dispatch(cmActions.setColumnVisibility({columnVisibility:newModel , table:"CMForecast"}));
					}
				}}
				/>
			</CustomAccordionDetails>
		</CustomAccordion>
	
	)
}

export default memo(CMForecastTable)
